import BaseLayout from "../layout/BaseLayout";
import { Box, Typography, IconButton, Chip, Stack } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useState } from "react";
import APIPermissions from "../component/ApiManagement/APIPermissions";
import TotalApiUsage from "../component/ApiManagement/TotalApiUsage";
import FeatureWiseUsage from "../component/ApiManagement/FeatureWiseUsage";

const Api = () => {
  const navigate = useNavigate();
  const { user_id } = useParams();

  const [activeTab, setActiveTab] = useState<
    "permission" | "usage" | "feature_usage"
  >("permission");

  return (
    <BaseLayout>
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        pt={2}
        mb={3}
      >
        <Box display="flex" alignItems="center">
          <IconButton onClick={() => navigate(-1)}>
            <KeyboardBackspaceIcon />
          </IconButton>
          <Typography fontSize={30} fontWeight={700}>
            {sessionStorage.getItem("user_name") || "User"}'s API Management
          </Typography>
        </Box>
      </Box>

      {/* Tabs (Chips) */}
      <Stack direction="row" spacing={2} mb={3}>
        <Chip
          label="API Permissions"
          clickable
          color={activeTab === "permission" ? "primary" : "default"}
          variant={activeTab === "permission" ? "filled" : "outlined"}
          onClick={() => setActiveTab("permission")}
        />

        <Chip
          label="Total API Usage"
          clickable
          color={activeTab === "usage" ? "primary" : "default"}
          variant={activeTab === "usage" ? "filled" : "outlined"}
          onClick={() => setActiveTab("usage")}
        />

        <Chip
          label="Feature-wise Usage"
          clickable
          color={activeTab === "feature_usage" ? "primary" : "default"}
          variant={activeTab === "feature_usage" ? "filled" : "outlined"}
          onClick={() => setActiveTab("feature_usage")}
        />
      </Stack>

      {/* Content */}
      {user_id && (
        <Box>
          {activeTab === "permission" && <APIPermissions user_id={user_id} />}
          {activeTab === "usage" && <TotalApiUsage user_id={user_id} />}
          {activeTab === "feature_usage" && (
            <FeatureWiseUsage user_id={user_id} />
          )}
        </Box>
      )}
    </BaseLayout>
  );
};

export default Api;
